const getDisplayNameFromUser = user => {
  if (!user) return null

  if (typeof user === 'string') {
    return user.trim() || null
  }

  return (
    [
      user.full_name,
      user.fullName,
      [user.first_name || user.firstName, user.last_name || user.lastName]
        .filter(Boolean)
        .join(' ')
        .trim(),
      user.name,
      user.email
    ].find(value => typeof value === 'string' && value.trim()) || null
  )
}

export const getTemplateCreatorId = template =>
  template?.creator_id ||
  template?.creatorId ||
  template?.creator?.id ||
  template?.created_by?.id ||
  template?.createdBy?.id ||
  template?.owner?.id ||
  template?.user_id ||
  template?.userId ||
  null

export const getTemplateAttachedById = template =>
  template?.attached_by?.id ||
  template?.attachedBy?.id ||
  template?.attached_by_id ||
  template?.uploaded_by?.id ||
  template?.uploadedBy?.id ||
  template?.uploaded_by_id ||
  null

export const canCurrentUserDetachTemplate = (template, currentUser) => {
  return canCurrentUserDetachTemplateFromBp(template, currentUser, null)
}

export const canCurrentUserDetachTemplateFromBp = (template, currentUser, bp) => {
  if (!template || !currentUser) return false

  const currentUserId = String(currentUser.id)
  const creatorId = getTemplateCreatorId(template)
  const isCreator = creatorId && String(creatorId) === currentUserId

  if (!isCreator) return false

  if (!bp) return isCreator

  if (bp?.status === 'dormant') return false

  if (currentUser?.type === 'emergency_service') return true

  const relatedIds = [
    ...(bp?.owners || []),
    ...(bp?.agents || []),
    ...(bp?.responsiblePersons || []),
    ...(bp?.principalAccountablePersons || []),
    ...(bp?.principalDesigners || []),
    ...(bp?.prospectivePurchasers || [])
  ]
    .map(item => String(item?.id ?? item?.pivot?.userId ?? ''))
    .filter(Boolean)

  return (
    String(bp?.creatorId || bp?.creator_id || '') === currentUserId ||
    relatedIds.includes(currentUserId)
  )
}

export const getTemplateOwnerName = template =>
  getDisplayNameFromUser(
    template?.creator ||
      template?.owner ||
      template?.created_by ||
      template?.createdBy ||
      template?.creator_name ||
      template?.creatorName ||
      template?.created_by_name ||
      template?.createdByName ||
      template?.owner_name ||
      template?.ownerName
  )

export const getTemplateAttachedByName = template =>
  getDisplayNameFromUser(
    template?.attached_by ||
      template?.attachedBy ||
      template?.attached_by_name ||
      template?.attachedByName ||
      template?.uploader ||
      template?.uploaded_by ||
      template?.uploadedBy
  )

export const getTemplateProvenanceLabel = template => {
  const ownerName = getTemplateOwnerName(template)
  const attachedByName = getTemplateAttachedByName(template)

  if (ownerName && attachedByName) {
    return ownerName === attachedByName
      ? ownerName
      : `${ownerName} · Added by ${attachedByName}`
  }

  if (ownerName) return ownerName
  if (attachedByName) return `Added by ${attachedByName}`

  return null
}
